// src/utils/avatarService.js
// Single place that saves a profile picture. Used by Profile and CompleteProfileModal
// so the two can never drift apart.
import { getAuth, updateProfile } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../firebase";
import { uploadAvatar } from "./imageUpload";
import { getAvatarUrl } from "./imageUrls";
import { clearCache } from "./simpleCache";

/**
 * @param {string} uid
 * @param {File|Blob|string} source  a File, or a blob:/data: URL
 * @returns {{ filePath: string, url: string }}
 */
export async function saveAvatar({ uid, source }) {
  const filePath = await uploadAvatar(source, uid);

  // Same two writes as before: Firebase Auth photoURL + Firestore users/{uid}.profileImage
  const authUser = getAuth().currentUser;
  if (authUser) await updateProfile(authUser, { photoURL: filePath });
  await setDoc(doc(db, "users", uid), { profileImage: filePath }, { merge: true });

  // So the new picture shows up straight away everywhere
  clearCache(`author-${uid}`);

  return { filePath, url: getAvatarUrl(filePath) };
}